import Controller from '@ember/controller';
import { action } from '@ember/object';

export default class IntegrationsWarehouseTypeSyncController extends Controller {
  @action
  onCreate() {
    this.send('reloadModel');
  }
}

declare module '@ember/controller' {
  interface Registry {
    'integrations.warehouse.type.sync': IntegrationsWarehouseTypeSyncController;
  }
}
